import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { EditionDocumentTypeView } from "./EditionDocumentTypeView";
import { EditionDocumentTypeViewStore } from "../../store/EditionDocumentTypeViewStore";
import { useStore } from "../../../../hooks";

export const EditionDocumentTypeViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/editionDocumentType/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new EditionDocumentTypeViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <EditionDocumentTypeView editionDocumentTypeViewStore={store} />
      </PageLayout>
    </div>
  );
});
